module.exports = __webpack_public_path__ + "img/_logo.7923748a.png";